import t from "./_tagTester.js";
import { root as o } from "./_setup.js";
var n = t("Function"),
  e = o.document && o.document.childNodes;
"function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof e && (n = function n(t) {
  return "function" == typeof t;
});
var r = n;
export { r as default };